<template>
  <div>
    <DashboardHeader title="Fees Structures">
      <v-row class="mt-6">
        <v-col :cols="isMobile ? 12 : 3">
          <v-card class="mx-2" v-if="isAdmin" shaped outlined>
            <v-list-item three-line>
              <v-autocomplete
                v-model="selectedFeesYear"
                label="Select Year"
                :items="FeesYearsOptions"
                @change="getFeesForSelectedYear()"
              ></v-autocomplete>
            </v-list-item>
          </v-card>

          <v-card class="mx-2 px-4 mt-4" v-if="isAdmin" shaped outlined>
            <v-text-field
              label="Fee ID eg. GrX-2022-D0-11M"
              v-model="feeID"
              :rules="nameRules"
            ></v-text-field>
            <v-autocomplete
              v-model="selectedFeesYearCreate"
              label="Select Year"
              :items="FeesYearsOptions"
              :rules="nameRules"
            ></v-autocomplete>
            <v-text-field
              label="Deposit"
              v-model="deposit"
              :rules="nameRules"
            ></v-text-field>
            <v-text-field
              label="Monthly Payments"
              v-model="monthly"
              :rules="nameRules"
            ></v-text-field>
            <v-text-field
              label="No. of Months"
              v-model="noOfMonths"
              :rules="nameRules"
            ></v-text-field>
            <v-text-field
              label="Starting Month"
              v-model="startingMonth"
              :rules="nameRules"
            ></v-text-field>
            <v-row>
              <v-btn
                rounded
                class="my-4 mx-auto"
                :color="getThemeColor"
                @click="addFeeStrucuture()"
                dark
              >
                <v-icon left>mdi-plus</v-icon>Submit
              </v-btn>
            </v-row>
          </v-card>
        </v-col>

        <v-col :cols="isMobile ? 12 : 9" class="mt-4 ">
          <v-card>
            <v-row>
              <v-col :cols="12">
                <v-switch
                  :disabled="feesForSelectedYear.length < 1"
                  v-model="selectAll"
                  label="Select All"
                  class="ml-8 mt-0"
                  @change="selectAllFees()"
                ></v-switch>
                <v-spacer></v-spacer>
                <v-text-field
                  class="mt-0 mx-6"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <span>
              <v-btn
                small
                rounded
                :color="getThemeColor"
                dark
                class="mx-4 mt-2"
                v-if="feesForSelectedYear.length > 0 && isAdmin"
                @click="editFees()"
              >
                <v-icon left>mdi-receipt</v-icon>Bulk Manage Fees
              </v-btn>
            </span>

            <span>
              <v-btn
                small
                rounded
                color="red"
                dark
                class="mx-4 mt-2"
                v-if="feesForSelectedYear.length > 0 && isAdmin"
                @click="openDeleteConfirmDialog()"
              >
                <v-icon left>mdi-delete</v-icon>Delete
              </v-btn>
            </span>

            <v-data-table
              :headers="feesTableHeaders"
              :items="feesForSelectedYear"
              :search="search"
            >
              <template v-slot:item.selection="{ item }">
                <v-checkbox
                  class="shrink"
                  :value="item.id"
                  v-model="selectedFees"
                ></v-checkbox>
              </template>
              <template v-slot:item.fid="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'fid')"
                  v-model="item.fid"
                ></v-text-field>
              </template>
              <template v-slot:item.year="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'year')"
                  v-model="item.year"
                ></v-text-field>
              </template>

              <template v-slot:item.deposit="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'deposit')"
                  v-model="item.deposit"
                ></v-text-field>
              </template>
              <template v-slot:item.monthly="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'monthly')"
                  v-model="item.monthly"
                ></v-text-field>
              </template>
              <template v-slot:item.months="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'months')"
                  v-model="item.months"
                ></v-text-field>
              </template>
              <template v-slot:item.starting_month="{ item }">
                <v-text-field
                  @change="updateField(item.id, 'starting_month')"
                  v-model="item.starting_month"
                ></v-text-field>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <GlobalConfirmDeleteDialog
          @delete-confirmed="takeActionAfterFeeDeleteChoice"
          item="Fee Structure"
        ></GlobalConfirmDeleteDialog>

        <GlobalDialogSlot
          :title="dialogTitle"
          :dialog="dialog"
          @close-dialog="closeDialog"
        >
          <v-card>
            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-card-title :style="{ color: getThemeColor }"
                  >Fee ID: {{ createdFeeStructure.fid }}</v-card-title
                >
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>

            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-card-title :style="{ color: getThemeColor }"
                  >Starting Year: {{ createdFeeStructure.year }}</v-card-title
                >
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>

            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-card-title :style="{ color: getThemeColor }"
                  >Deposit: {{ createdFeeStructure.deposit }}</v-card-title
                >
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>

            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-card-title :style="{ color: getThemeColor }"
                  >Monthly Payments:
                  {{ createdFeeStructure.monthly }}</v-card-title
                >
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>

            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="4">
                <v-card-title :style="{ color: getThemeColor }"
                  >No. of Months: {{ createdFeeStructure.months }}</v-card-title
                >
              </v-col>
              <v-col cols="4"></v-col>
            </v-row>
          </v-card>
        </GlobalDialogSlot>
      </v-row>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import GlobalConfirmDeleteDialog from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  components: { DashboardHeader, GlobalConfirmDeleteDialog, GlobalDialogSlot },
  computed: {
    getGlobalConfirmDelete() {
      return this.$store.getters.getGlobalConfirmDelete;
    },
    getSelectedClass() {
      return this.$store.getters.getSelectedClass;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getBulkSMSTokenSecret() {
      return this.$store.getters.getBulkSMSTokenSecret;
    },
    getBulkSMSBasicAuth() {
      return this.$store.getters.getBulkSMSBasicAuth;
    },
  },
  mounted() {
    let curDate = new Date().getFullYear();
    curDate = Number(curDate) - 7;

    this.FeesYearsOptions.push("All Years");
    for (let i = 0; i < 14; i++) {
      this.FeesYearsOptions.push(curDate + i);
    }
    this.FeesYearsOptions.unshift(new Date().getFullYear());
    this.updateSchoolFeesIDs();
    this.getFeesForSelectedYear();
  },
  data: () => ({
    dialogTitle: null,
    dialog: false,
    nameRules: [(v) => !!v || "Field is required"],
    search: null,
    selectAll: false,
    FeesYearsOptions: [],
    selectedFeesYear: new Date().getFullYear(),
    feesForSelectedYear: [],
    selectedFees: [],
    feeID: null,
    selectedFeesYearCreate: new Date().getFullYear(),
    deposit: 0,
    monthly: 0,
    noOfMonths: 11,
    startingMonth: 1,
    createdFeeStructure: {},
    feesTableHeaders: [
      { value: "selection" },
      { text: "Fee ID", value: "fid" },
      {
        text: "Year Started",
        value: "year",
      },
      { text: "Deposit", value: "deposit" },
      { text: "Monthly", value: "monthly" },
      { text: "Months", value: "months" },
      { text: "Starting Month", value: "starting_month" },
    ],
  }),
  methods: {
    updateSchoolFeesIDs() {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/update-school-fees-ids", this.getAccessToken)
        .then(() => {
          this.$store.commit("setLoader", false);
        });
    },
    getFeesForSelectedYear() {
      this.$store.commit("setLoader", true);
      this.selectedFees = [];
      axios
        .postDataWithToken(
          "/auth/get-fees-for-selected-year",
          { selectedFeesYear: this.selectedFeesYear },
          this.getAccessToken
        )
        .then((feesForSelectedYear) => {
          this.feesForSelectedYear = feesForSelectedYear;
          this.$store.commit("setLoader", false);
        });
    },
    selectAllFees() {
      if (this.selectAll) {
        this.selectedFees = [];
        this.feesForSelectedYear.forEach((feeForSelectedYear) => {
          this.selectedFees.push(feeForSelectedYear.id);
        });
      } else {
        this.selectedFees = [];
      }
    },
    updateField(id, column) {
      const value = event.target.value;
      axios.postDataWithToken(
        "/auth/update-item",
        { table: "fees_all_times", id, column, value },
        this.getAccessToken
      );
    },
    addFeeStrucuture() {
      if (
        this.feeID != null &&
        this.selectedFeesYearCreate != null &&
        this.deposit != null &&
        this.monthly != null &&
        this.noOfMonths != null &&
        this.startingMonth != null
      ) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/create-fee-structure",
            {
              feeID: this.feeID,
              selectedFeesYearCreate: this.selectedFeesYearCreate,
              deposit: this.deposit,
              monthly: this.monthly,
              noOfMonths: this.noOfMonths,
              startingMonth: this.startingMonth,
            },
            this.getAccessToken
          )
          .then((createdFeeStructure) => {
            this.dialogTitle = "Fee Structure Created Successfully";
            this.createdFeeStructure = createdFeeStructure;
            this.dialog = true;
            this.$store.commit("setLoader", false);
          });
      } else {
        alert("All Fields Are Required!");
        event.preventDefault();
      }
    },
    takeActionAfterFeeDeleteChoice(choice) {
      if (choice) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/delete-selected-fees",
            {
              selectedFees: this.selectedFees,
              selectedFeesYear: this.selectedFeesYear,
            },
            this.getAccessToken
          )
          .then((feesForSelectedYear) => {
            this.selectedFees = [];
            this.feesForSelectedYear = feesForSelectedYear;
            this.$store.commit("setLoader", false);
          });
      } else {
        this.$store.commit("setGlobalConfirmDelete", false);
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    openDeleteConfirmDialog() {
      if (this.selectedFees.length > 0) {
        this.$store.commit("setGlobalConfirmDelete", true);
      } else {
        alert("Select Atleast 1 Fee Structure to Delete!");
        event.preventDefault();
      }
    },
    deleteBulkNow() {
      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/bulk-delete-students",
          {
            table: "fees_all_times",
            sids: this.selectedStudents,
            selectedClass: this.selectedClass,
          },
          this.getAccessToken
        )
        .then((students) => {
          this.selectedStudents = [];
          this.snackbarText = "Selected Students Successfully Deleted!";
          this.snackbarColor = "success";
          this.students = students;
          this.$store.commit("setLoader", false);
          this.closeDialog();
          this.snackbarModel = true;
        });
    },
    editFees() {
      if (this.selectedFees.length > 0) {
        this.$router.push({
          name: "edit-fees-structures",
          params: { selectedFees: this.selectedFees },
        });
      } else {
        alert("Select Atleast 1 Fee Structure to Edit!");
        event.preventDefault();
      }
    },
  },
};
</script>

<style></style>
